import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { X, Loader2 } from 'lucide-react';
import { RichTextEditor } from '../RichTextEditor';

export function ReviseModal({ isOpen, onClose, onSubmit, loading }) {
  const [remarks, setRemarks] = useState('');

  useEffect(() => { if (isOpen) setRemarks(''); }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="revise-modal">
      <div className="bg-white rounded-lg w-full max-w-md">
        <div className="p-4 border-b flex justify-between items-center">
          <h2 className="font-semibold">Revise Quote</h2>
          <button onClick={onClose}><X size={20} /></button>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); if (!remarks.trim()) { toast.error('Please enter a reason for the revision'); return; } onSubmit(remarks); }} className="p-6 space-y-4">
          <p className="text-sm text-slate-600">This will create a new revision of the quote. The current quote will be marked as revised. Please provide a reason:</p>
          <div>
            <label className="block text-sm font-medium mb-1">Reason for Revision <span className="text-red-500">*</span></label>
            <textarea
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded text-sm"
              rows={4}
              placeholder="Why is this quote being revised?"
              data-testid="revise-reason"
              autoFocus
            />
          </div>
          <div className="flex justify-end gap-3 pt-2 border-t">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm border border-slate-300 rounded">Cancel</button>
            <button type="submit" disabled={loading} className="px-4 py-2 text-sm bg-cyan-500 text-white rounded hover:bg-cyan-600 flex items-center gap-2" data-testid="revise-submit">
              {loading && <Loader2 size={16} className="animate-spin" />}
              Revise
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Comments Section

